(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\main.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _svgInjector = require('./modules/svgInjector');

var _parallax = require('./modules/parallax');

var _imagePopUp = require('./modules/imagePopUp');

var _carousels = require('./modules/carousels');

var _miniGallery = require('./modules/miniGallery');

var _displayNews = require('./modules/displayNews');

var _cookies = require('./modules/cookies');

var _responsiveImages = require('./modules/responsiveImages');

var _hamburgerMenu = require('./modules/hamburgerMenu');

var _scrollTo = require('./modules/scrollTo');

var _googleMaps = require('./modules/googleMaps');

var _video = require('./modules/video');

var _tabsSection = require('./modules/tabsSection');

var _validator = require('./modules/validator');

var _sidePanel = require('./modules/sidePanel');

var _navigation = require('./modules/navigation');

var _submenu = require('./modules/submenu');

var _visible = require('./modules/visible');

var _newsletter = require('./modules/newsletter');

var _select = require('./modules/select2');

var _coverImage = require('./modules/coverImage');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var svgInjector = new _svgInjector.SvgInjector();
var parallax = new _parallax.Parallax();
var imagePopUp = new _imagePopUp.ImagePopUp();
var carousels = new _carousels.Carousels();
var miniGallery = new _miniGallery.MiniGallery();
var displayNews = new _displayNews.DisplayNews();
var cookies = new _cookies.Cookies();
var responsiveImages = new _responsiveImages.ResponsiveImages();
var hamburgerMenu = new _hamburgerMenu.HamburgerMenu();
var scrollTo = new _scrollTo.ScrollTo();
var googleMaps = new _googleMaps.GoogleMaps();
var video = new _video.Video();
var tabsSection = new _tabsSection.TabsSection();
var validator = new _validator.Validator();
var sidePanel = new _sidePanel.SidePanel();
var navigation = new _navigation.Navigation();
var submenu = new _submenu.Submenu();
var visible = new _visible.Visible();
var newsletterSubscription = new _newsletter.NewsletterSubscription();
var select2 = new _select.Select2();
var coverImage = new _coverImage.CoverImage();

var Main = function () {
  function Main(node_env) {
    _classCallCheck(this, Main);

    this.node_env = node_env;
    this.sections = $('.cms-section');
    // jcf.setOptions('Select', {
    //   wrapNative: false,
    //   maxVisibleItems: 8
    // });
    // jcf.replaceAll();
  }

  _createClass(Main, [{
    key: 'bootstrap',
    value: function bootstrap(callback) {
      var $sections = $(this.sections);
      this.modules($sections);
      this.responsiveModules($sections);
      callback();
    }
  }, {
    key: 'modules',
    value: function modules($sections) {
      parallax.init($sections);
      svgInjector.init();
      imagePopUp.init();
      carousels.init();
      miniGallery.init();
      displayNews.init();
      cookies.init();
      responsiveImages.init($sections);
      hamburgerMenu.init();
      scrollTo.init();
      googleMaps.init();
      video.init();
      tabsSection.init();
      validator.init();
      sidePanel.init();
      navigation.init();
      submenu.init();
      visible.init();
      newsletterSubscription.init();
      select2.init();
      coverImage.init();
    }
  }, {
    key: 'responsiveModules',
    value: function responsiveModules($sections) {
      $(window).resize(function () {
        parallax.init($sections);
        carousels.init();
        miniGallery.init();
        displayNews.init();
        responsiveImages.init($sections);
      });

      $(window).scroll(function () {
        $('.video-player').each(function (id, videoPlayer) {
          if ($(videoPlayer).visible(true)) {
            video.play($(videoPlayer));
          } else {
            video.stop($(videoPlayer));
          }
        });
      });
    }
  }]);

  return Main;
}();

$(window).load(function () {
  var main = new Main('development');
  main.bootstrap(function () {
    $('#page-overlay').fadeOut(800);
  });
});

},{"./modules/carousels":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\carousels.js","./modules/cookies":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\cookies.js","./modules/coverImage":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\coverImage.js","./modules/displayNews":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\displayNews.js","./modules/googleMaps":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\googleMaps.js","./modules/hamburgerMenu":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\hamburgerMenu.js","./modules/imagePopUp":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\imagePopUp.js","./modules/miniGallery":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\miniGallery.js","./modules/navigation":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\navigation.js","./modules/newsletter":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\newsletter.js","./modules/parallax":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\parallax.js","./modules/responsiveImages":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\responsiveImages.js","./modules/scrollTo":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\scrollTo.js","./modules/select2":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\select2.js","./modules/sidePanel":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\sidePanel.js","./modules/submenu":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\submenu.js","./modules/svgInjector":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\svgInjector.js","./modules/tabsSection":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\tabsSection.js","./modules/validator":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\validator.js","./modules/video":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\video.js","./modules/visible":"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\visible.js"}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\carousels.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Carousels = exports.Carousels = function () {
	function Carousels() {
		_classCallCheck(this, Carousels);
	}

	_createClass(Carousels, [{
		key: 'init',
		value: function init() {
			var carouselThumbs = $('.gallery-thumbs .owl-carousel'),
			    carouselZoom = $('.gallery-category--zoom-slider .owl-carousel'),
			    pluginFlag = carouselThumbs.length || carouselZoom.length;

			if (pluginFlag) if (carouselThumbs) this.carouselThumbs(carouselThumbs);
			if (carouselZoom) this.carouselZoom(carouselZoom);
		}
	}, {
		key: 'carouselThumbs',
		value: function carouselThumbs(carousel) {
			carousel.owlCarousel({
				items: 1,
				loop: true,
				margin: 0,
				nav: true,
				dots: false,
				thumbs: false,
				thumbsPrerendered: false,
				autoplay: true,
				autoplayTimeout: 3000,
				autoplaySpeed: 1000,
				autoplayHoverPause: true,
				navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
				onInitialized: function onInitialized(event) {
					$('.all-pages').html(event.item.count);

					$('.owl-dot').each(function () {
						var $this = $(this),
						    item = $this.closest('.gallery-thumbs--global-slider').find('.owl-item.active .gt-item__text');
						console.log($this, $this.closest('.gallery-thumbs--global-slider'), item);
						$this.hover(function () {
							item.addClass('show');
						}, function () {
							item.removeClass('show');
						});
					});
				},
				onChanged: function onChanged(e) {
					var itemsLength = this._items.length;

					var $slider = this.$element.parents('.gallery-thumbs'),
					    $slides = $slider.find('.owl-carousel .owl-item:not(.cloned)'),
					    $thumbs = $slider.find('.gallery-thumbs__thumbs'),
					    $thumbsContainer = $thumbs.find('.gt-thumbs__container'),
					    $thumbsList = $thumbs.find('.owl-thumbs');

					var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
					    thumbsListWidth = thumbWidth * itemsLength,
					    thumbsContainerWidth = $thumbsContainer.width();

					var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
					    thumbsPositionPart = thumbsOuterWidth / itemsLength;

					var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
					    currentSlide = $slides.eq(currentPosition);

					if (thumbsOuterWidth > 0) {
						$thumbsList.css({
							'-webkit-transform': 'translateX(' + (-currentPosition + 1) * thumbsPositionPart + 'px)',
							'-mox-transform': 'translateX(' + (-currentPosition + 1) * thumbsPositionPart + 'px)',
							'transform': 'translateX(' + (-currentPosition + 1) * thumbsPositionPart + 'px)'
						});
					}

					setTimeout(function () {
						currentSlide.addClass('active');
					});
					setTimeout(function () {
						$('.owl-dots').children().each(function (i) {
							$(this).find('span').html(i + 1);
						});
						var page = $('.owl-dot.active span').text();
						$('.current-page').html(page);
					}, 100);
				}
			});
		}
	}, {
		key: 'carouselZoom',
		value: function carouselZoom(carousel) {
			carousel.owlCarousel({
				stagePadding: 40,
				loop: true,
				autoWidth: false,
				center: true,
				margin: 0,
				responsive: {
					0: {
						items: 3,
						autoWidth: true
					},
					320: {
						items: 3
					},
					641: {
						items: 3,
						autoWidth: true,
						center: false
					},
					1024: {
						items: 4,
						center: true,
						autoWidth: true
					},
					1350: {
						items: 7,
						center: true,
						autoWidth: true
					}
				}
			});

			carousel.find('.owl-item').on('click', function () {
				var $this = $(this),
				    index = $this.index(),
				    itemsLength = $this.siblings('.owl-item').length,
				    itemsHandler = $this.closest('.owl-stage-outer'),
				    activeItems = $this.closest('.gallery-category--zoom-slider').find('.active');

				if ($this.hasClass('zoomed')) {
					$this.removeClass('zoomed');
				} else if ($this.prev().hasClass('active') && $this.next().hasClass('active') || !$this.prev().hasClass('active') && !$this.next().hasClass('active')) {
					$('.zoomed').removeClass('zoomed');
					$this.addClass('zoomed');
				} else if ($this.prev().hasClass('active') && !$this.next().hasClass('active')) {
					carousel.trigger('next.owl.carousel', [500]);
					$('.zoomed').removeClass('zoomed');
					$this.addClass('zoomed');
				} else if (!$this.prev().hasClass('active') && $this.next().hasClass('active')) {
					carousel.trigger('prev.owl.carousel', [500]);
					$('.zoomed').removeClass('zoomed');
					$this.addClass('zoomed');
				}
			});
		}
	}]);

	return Carousels;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\cookies.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = exports.Cookies = function () {
	function Cookies() {
		_classCallCheck(this, Cookies);
	}

	_createClass(Cookies, [{
		key: 'init',
		value: function init() {
			$(document).ready(function () {

				if ($.cookie("cookie_agree") == 1) {
					$('.cookies-tab').hide();
				} else {
					$('.cookies-tab').fadeIn(500);
				}

				$('.cookies-tab .button').click(function () {
					cookieAgree();
					return false;
				});
			});

			function cookieAgree() {
				$.cookie("cookie_agree", 1, { expires: 365, path: '/' });
				$('.cookies-tab').fadeOut(400);
			}
		}
	}]);

	return Cookies;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\coverImage.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CoverImage = exports.CoverImage = function () {
	function CoverImage() {
		_classCallCheck(this, CoverImage);
	}

	_createClass(CoverImage, [{
		key: 'init',
		value: function init() {
			var coverImage = document.querySelector('.cover-image');
			var firstSection = document.querySelector('.upcoming_concerts_container');

			if (typeof firstSection === 'undefined' || firstSection === null) {
				return;
			}

			if (coverImage) {
				firstSection.style.paddingTop = '300px';
			} else {
				firstSection.style.paddingTop = '80px';
			}
		}
	}]);

	return CoverImage;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\displayNews.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplayNews = exports.DisplayNews = function () {
	function DisplayNews() {
		_classCallCheck(this, DisplayNews);
	}

	_createClass(DisplayNews, [{
		key: 'init',
		value: function init() {
			var newsImage = $('.news--image'),
			    newsBoxes = $('.news--boxes'),
			    windowWidth = $(window).width();

			var newsImageLength = newsImage.length;
			if (newsImageLength) {
				for (var i = newsImageLength; i--;) {
					var thisNews = newsImage[i],
					    thisNewsWidth = $(thisNews).width(),
					    newsImageItems = $(thisNews).find('.news__item'),
					    newsImageItemsLength = newsImageItems.length;

					var largeWidth = 1180 / 12 * 8 + 20,
					    middleWidth = 1180 / 12 * 6 + 20,
					    smallWidth = 1180 / 12 * 4 + 20;

					if ($(thisNews).hasClass('news--image-side')) {
						if (thisNewsWidth < largeWidth && thisNewsWidth >= middleWidth || thisNewsWidth < smallWidth) {
							$(thisNews).find('.news__item').addClass('display-column');
						} else {
							$(thisNews).find('.news__item').removeClass('display-column');
						}
					}
					if (thisNewsWidth < largeWidth && thisNewsWidth >= middleWidth) {
						newsImageItems.removeClass('same-width-1 same-width-2').addClass('same-width-3');
					} else if (thisNewsWidth < middleWidth && thisNewsWidth > smallWidth) {
						newsImageItems.removeClass('same-width-1 same-width-3').addClass('same-width-2');
					} else if (thisNewsWidth < smallWidth) {
						newsImageItems.removeClass('same-width-2 same-width-3').addClass('same-width-1');
					} else {
						newsImageItems.removeClass('same-width-1 same-width-2 same-width-3');
					}
				}
			}

			var newsBoxesLength = newsBoxes.length;
			if (newsBoxesLength) {
				var _loop = function _loop() {
					var thisNews = newsBoxes[i],
					    newsHeight = 0,
					    newsItems = $(thisNews).find('.news__item');

					newsItems.each(function (id, item) {
						var itemHeight = $(item).height();
						if (itemHeight > newsHeight) {
							newsHeight = itemHeight;
						}
					});

					newsItems.find('.ni__content').innerHeight(newsHeight);
				};

				for (var i = newsBoxesLength; i--;) {
					_loop();
				}
			}
		}
	}]);

	return DisplayNews;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\googleMaps.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMaps = exports.GoogleMaps = function () {
	function GoogleMaps() {
		_classCallCheck(this, GoogleMaps);
	}

	_createClass(GoogleMaps, [{
		key: 'init',
		value: function init() {
			var self = this;
			if ($('.google-map').length) {
				$(document).ready(function () {
					self.geocode();
				});
			}
		}
	}, {
		key: 'geocode',
		value: function geocode() {
			$('.google-map').each(function (id, mapSection) {
				var address = $(mapSection).data('address'),
				    mapContent = $(mapSection).find('.google-map__content').attr('id');
				var mapOptions = {
					zoom: 15,
					center: new google.maps.LatLng(40.6700, -73.9400),
					styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
				};

				var mapElement = document.getElementById(mapContent);

				var map = new google.maps.Map(mapElement, mapOptions);
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'address': address }, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						map.setCenter(results[0].geometry.location);
						var marker = new google.maps.Marker({
							map: map,
							position: results[0].geometry.location
						});
					}
				});
			});
		}
	}]);

	return GoogleMaps;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\hamburgerMenu.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HamburgerMenu = exports.HamburgerMenu = function () {
	function HamburgerMenu() {
		_classCallCheck(this, HamburgerMenu);
	}

	_createClass(HamburgerMenu, [{
		key: 'init',
		value: function init() {
			var $mobileNav = $('.mobile-nav'),
			    $hamburger = $('.js-mobile-nav'),
			    $navElements = $mobileNav.find('.mobile-nav__content li');

			$('.js-mobile-nav').on('click', function () {
				$hamburger.toggleClass('is-active');
				$mobileNav.fadeToggle(function () {
					if ($mobileNav.is(':visible')) {
						for (var i = 0; i < $navElements.length; i++) {
							$($navElements[i]).css({ 'transition-delay': i * 50 + 'ms' }).addClass('fadeIn');
						}
					} else {
						$navElements.removeClass('fadeIn');
					}
				});
			});
		}
	}]);

	return HamburgerMenu;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\imagePopUp.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImagePopUp = exports.ImagePopUp = function () {
  function ImagePopUp() {
    _classCallCheck(this, ImagePopUp);
  }

  _createClass(ImagePopUp, [{
    key: 'init',
    value: function init() {
      $('.picture a').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: true,
        mainClass: 'mfp-no-margins mfp-with-zoom',
        image: {
          verticalFit: true
        },
        zoom: {
          enabled: true,
          duration: 300
        }
      });
    }
  }]);

  return ImagePopUp;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\miniGallery.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MiniGallery = exports.MiniGallery = function () {
	function MiniGallery() {
		_classCallCheck(this, MiniGallery);
	}

	_createClass(MiniGallery, [{
		key: 'init',
		value: function init() {
			var miniGalleryLength = $('.mini-gallery').length,
			    noGridGalleryLength = $('.js-no-grid').length;

			if (miniGalleryLength) {
				for (var i = miniGalleryLength; i--;) {
					var element = $('.mini-gallery')[i];
					$(element).magnificPopup({
						delegate: 'a',
						type: 'image',
						closeOnContentClick: true,
						closeBtnInside: false,
						fixedContentPos: true,
						mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
						image: {
							verticalFit: true
						},
						tLoading: 'Ładuję...',
						gallery: {
							enabled: true,
							tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
						},
						zoom: {
							enabled: false,
							duration: 300 // don't foget to change the duration also in CSS
						}
					});
				}
			}

			if (noGridGalleryLength) {
				var noGridGalleries = $('.js-no-grid');
				noGridGalleries.each(function (galleryId, gallery) {
					var galleryItems = $(gallery).find('.js-no-grid-item'),
					    galleryColumns = $(gallery).data('columns') ? $(gallery).data('columns') : 3,
					    galleryContainerColumns = null,
					    galleryItemsArary = [];

					var galleryContainer = $('<div class="row"></div>');
					for (var i = 0; i < galleryColumns; i++) {
						var galleryCol = $('<div class="col-md-' + 12 / galleryColumns + '"></div>');
						galleryContainer.append(galleryCol);
					}

					$(gallery).append(galleryContainer);
					galleryContainerColumns = galleryContainer.find('[class*="col-md"]');

					galleryItems.each(function (id, galleryItem) {
						var minHeight = 10000000000,
						    selectedCol = null;
						for (var i = 0; i < galleryContainerColumns.length; i++) {
							var colHeight = $(galleryContainerColumns[i]).height();

							if (colHeight < minHeight) {
								minHeight = colHeight;
								selectedCol = $(galleryContainerColumns[i]);
							}
						}
						selectedCol.append($(galleryItem).clone(true));
					});
					$(gallery).html(galleryContainer);
				});
			}
		}
	}]);

	return MiniGallery;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\navigation.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Navigation = exports.Navigation = function () {
	function Navigation() {
		_classCallCheck(this, Navigation);
	}

	_createClass(Navigation, [{
		key: 'init',
		value: function init() {
			$('.site-header li').each(function () {
				var $this = $(this);
				if ($this.children('.submenu').length) {
					$this.addClass('has-child');
				} else if ($this.children('ul').length) {
					$this.addClass('has-list');

					var w = $this.innerWidth();
					$this.closest('.submenu').css('width', w += w);
				}
			});
		}
	}]);

	return Navigation;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\newsletter.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewsletterSubscription = exports.NewsletterSubscription = function () {
    function NewsletterSubscription() {
        _classCallCheck(this, NewsletterSubscription);

        this.genresLoaded = false;
        this.errorContainer = $('#alert-danger');
        this.errorContent = $('#alert-danger .content');
        this.successContainer = $('#alert-success');
        this.successContent = $('#alert-success .content');
    }

    _createClass(NewsletterSubscription, [{
        key: 'init',
        value: function init() {
            var _this = this;

            $(document).ready(function () {
                _this.initGenreSelect();
                _this.initFormSubmit();
            });
        }
    }, {
        key: 'initGenreSelect',
        value: function initGenreSelect() {
            var apiUrl = window.localVariables.genresApiUrl;

            if (!apiUrl) {
                console.error('Nie można pobrać gatunków muzycznych');
                return;
            }

            $('#genre-select').select2({
                language: window.localVariables.currentLanguage,
                ajax: {
                    url: apiUrl,
                    success: function success(data) {
                        this.genresLoaded = true;
                    },
                    processResults: function processResults(data) {
                        var genres = [];
                        Object.entries(data.genres).forEach(function (_ref) {
                            var _ref2 = _slicedToArray(_ref, 2),
                                id = _ref2[0],
                                name = _ref2[1];

                            genres.push({
                                id: id,
                                text: name
                            });
                        });

                        genres.sort(function (a, b) {
                            return a.text.localeCompare(b.text);
                        });

                        return {
                            results: genres
                        };
                    }
                }
            });
        }
    }, {
        key: 'initFormSubmit',
        value: function initFormSubmit() {
            var _this2 = this;

            $('#newsletter-form').on('submit', function (e) {
                e.preventDefault();
                _this2.hideAlerts();
                _this2.submitForm();
            });
        }
    }, {
        key: 'hideAlerts',
        value: function hideAlerts() {
            if (this.errorContainer) {
                this.errorContainer.slideUp();
            }

            if (this.successContainer) {
                this.successContainer.slideUp();
            }
        }
    }, {
        key: 'submitForm',
        value: function submitForm() {
            var _this3 = this;

            var $this = $('#newsletter-form');
            var formData = $this.serialize();

            $.ajax({
                url: $this.attr('action'),
                method: 'POST',
                data: formData,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function success(response) {
                    console.log(response);

                    if (response.success) {
                        _this3.handleFormSuccessMessage([response.success]);
                    }

                    $('#newsletter-form')[0].reset();
                    $('#newsletter-form select').val(null).trigger('change');
                },
                error: function error(xhr) {
                    _this3.handleErrors(xhr);
                }
            });
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(response) {
            if (response.status === 422) {
                this.handleFormErrors(response.responseJSON);

                return;
            }

            if (typeof response.responseJSON.error !== 'undefined') {
                this.handleFormErrors([response.responseJSON.error]);

                return;
            }

            this.handleFormErrors(['Wystąpił błąd przy zapisie do newslettera. Prosimy spróbować później.']);
        }
    }, {
        key: 'handleFormErrors',
        value: function handleFormErrors(errors) {
            var _this4 = this;

            if (_typeof(this.errorContainer) == undefined || _typeof(this.errorContent) == undefined) {
                return;
            }

            this.errorContainer.slideDown();
            this.errorContent.empty();

            $.each(errors, function (key, value) {
                _this4.errorContent.append('<p>' + value + '</p>');
            });
        }
    }, {
        key: 'handleFormSuccessMessage',
        value: function handleFormSuccessMessage(errors) {
            var _this5 = this;

            if (_typeof(this.successContainer) == undefined || _typeof(this.successContent) == undefined) {
                return;
            }

            this.successContainer.slideDown();
            this.successContent.empty();

            $.each(errors, function (key, value) {
                _this5.successContent.append('<p>' + value + '</p>');
            });
        }
    }]);

    return NewsletterSubscription;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\parallax.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Parallax = exports.Parallax = function () {
  function Parallax() {
    _classCallCheck(this, Parallax);
  }

  _createClass(Parallax, [{
    key: 'init',
    value: function init($sections) {
      if ($(window).width() > 1020) {
        $(window).scroll(function () {
          var wScrollTop = $(window).scrollTop();
          $('.cms-section[data-parallax="true"]').each(function (id, item) {
            if ($(this).visible(true)) {
              var itemTop = $(this).offset().top;
              var s = wScrollTop - itemTop;
              $(this).find('.s-background .s-background__img').css({
                'transform': 'translateY(' + s * 0.3 + 'px)',
                '-webkit-transform': 'translateY(' + s * 0.3 + 'px)',
                '-moz-transform': 'translateY(' + s * 0.3 + 'px)'
              });
            }
          });
        });
      }
    }
  }]);

  return Parallax;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\responsiveImages.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResponsiveImages = exports.ResponsiveImages = function () {
	function ResponsiveImages() {
		_classCallCheck(this, ResponsiveImages);
	}

	_createClass(ResponsiveImages, [{
		key: 'init',
		value: function init($sections) {
			var imagesSrc = $sections.find('.js-image-src'),
			    windowSize = $(window).width() <= 720 ? 'mobile' : 'desktop';

			for (var i = imagesSrc.length; i--;) {
				var item = $(imagesSrc[i]);
				if (item.data('src-type') === 'background') {
					item.css({ 'background-image': 'url("' + item.data('image-src-' + windowSize) + '")' });
				} else {
					item.attr('src', item.data('image-src-' + windowSize));
				}
			}
		}
	}]);

	return ResponsiveImages;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\scrollTo.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollTo = exports.ScrollTo = function () {
	function ScrollTo() {
		_classCallCheck(this, ScrollTo);
	}

	_createClass(ScrollTo, [{
		key: 'init',
		value: function init() {
			$('.scroll-to a').on('click', function (e) {
				e.preventDefault();
				var distElement = $(this).attr('href'),
				    distElementTop = $(distElement).offset().top - 15;

				$('html, body').animate({
					scrollTop: distElementTop
				}, 500);
			});
		}
	}]);

	return ScrollTo;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\select2.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Select2 = exports.Select2 = function () {
    function Select2() {
        _classCallCheck(this, Select2);
    }

    _createClass(Select2, [{
        key: 'init',
        value: function init() {
            $(document).ready(function () {
                $('select.select2').select2();
            });
        }
    }]);

    return Select2;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\sidePanel.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SidePanel = exports.SidePanel = function () {
	function SidePanel() {
		_classCallCheck(this, SidePanel);
	}

	_createClass(SidePanel, [{
		key: 'init',
		value: function init() {
			if ((typeof sidePanelOptions === 'undefined' ? 'undefined' : _typeof(sidePanelOptions)) == 'object') {
				var self = this,
				    currentCookie = $.cookie('side-panel-' + sidePanelOptions.siteId) ? $.parseJSON($.cookie('side-panel-' + sidePanelOptions.siteId)) : undefined,
				    body = $('body');

				$.cookie.json = true;

				$(document).ready(function () {
					if (currentCookie == undefined || currentCookie.id != sidePanelOptions.id) {
						sidePanelOptions.closed = 0;
						$.cookie('side-panel-' + sidePanelOptions.siteId, sidePanelOptions, { expires: 365, path: '/' });
						self.checkRevealType();
					} else {
						if (currentCookie.closed == 0 && sidePanelOptions.reactive == 0 || currentCookie.closed == 1 && currentCookie.reactive == 0 && sidePanelOptions.reactive == 1) {
							self.checkRevealType();
						}
					}

					body.on('click', '.side-panel__close', function () {
						self.hidePanel();
					});
					body.on('click', '.side-panel.close', function () {
						self.reopenPanel();
					});
				});
			}
		}
	}, {
		key: 'reopenPanel',
		value: function reopenPanel() {
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('close').addClass('open').fadeIn();
			});
		}
	}, {
		key: 'showPanel',
		value: function showPanel() {
			$('.side-panel').fadeIn(function () {
				$(this).removeClass('close').addClass('open');
			});
		}
	}, {
		key: 'hidePanel',
		value: function hidePanel() {
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('open').addClass('close').show();
			});
			var cookie = $.cookie('side-panel-' + sidePanelOptions.siteId);

			cookie.closed = 1;
			sidePanelOptions.reactive == 1 ? cookie.reactive = 1 : cookie.reactive = 0;
			$.cookie('side-panel-' + sidePanelOptions.siteId, cookie, { expires: 365, path: '/' });
		}
	}, {
		key: 'showAfterTime',
		value: function showAfterTime(time) {
			var self = this;
			var delay = parseInt(time) * 1000;
			setTimeout(function () {
				self.showPanel();
			}, delay);
		}
	}, {
		key: 'showAfterDistance',
		value: function showAfterDistance(distance) {
			var self = this,
			    notClosed = true;
			$(window).scroll(function () {
				var st = $(window).scrollTop();

				if (st > distance && notClosed) {
					self.showPanel();
					notClosed = false;
				}
			});
		}
	}, {
		key: 'checkRevealType',
		value: function checkRevealType() {
			var self = this;

			if (sidePanelOptions.distance != 0) {
				self.showAfterDistance(sidePanelOptions.distance);
			} else if (sidePanelOptions.time != 0) {
				self.showAfterTime(sidePanelOptions.time);
			}
		}
	}]);

	return SidePanel;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\submenu.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Submenu = exports.Submenu = function () {
	function Submenu() {
		_classCallCheck(this, Submenu);
	}

	_createClass(Submenu, [{
		key: 'init',
		value: function init() {
			$('.submenu').siblings('a').css('cursor', 'default').click(function (e) {
				e.preventDefault();
				if ($(window).width() < 860) {
					$(this).siblings('.submenu').toggleClass('open');
				}
			});
		}
	}]);

	return Submenu;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\svgInjector.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SvgInjector = exports.SvgInjector = function () {
	function SvgInjector() {
		_classCallCheck(this, SvgInjector);
	}

	_createClass(SvgInjector, [{
		key: 'init',
		value: function init() {
			var mySVGsToInject = document.querySelectorAll('img.inject-svg');
			SVGInjector(mySVGsToInject, {}, function () {
				$('.contact-map--transparent path').hover(function () {
					var pathID = $(this).attr('id');
					$('.contact-map--color path[id="' + pathID + '"]').css({ 'fill': '#003179' });
				}, function () {
					$('.contact-map--color path').css({ 'fill': 'rgb(210, 220, 237)' });
				});

				$('.contact-map--transparent path').on('click', function () {
					$('.map-infos').hide();
					var tabID = $(this).attr('id');
					$('.contact-map--color path').attr('class', 'swisspor-area');
					$('.contact-map--color path[id="' + tabID + '"]').attr('class', 'swisspor-area active');
					$('.map-item').hide();
					$('.map-item[data-tab="' + tabID + '"]').show();
				});

				$('.js--regions').on('click', function () {
					$(this).closest('.map-item__regions').find('.regions-list').slideToggle();
				});
			});
		}
	}]);

	return SvgInjector;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\tabsSection.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TabsSection = exports.TabsSection = function () {
	function TabsSection() {
		_classCallCheck(this, TabsSection);
	}

	_createClass(TabsSection, [{
		key: 'init',
		value: function init() {
			var $tabsSections = $('.cms-section[data-tabs="true"]');
			if ($tabsSections.length) {
				$tabsSections.each(function (tabsSectionId, tabsSection) {
					var $tabsSection = $(tabsSection),
					    $tabsSectionItems = $tabsSection.find('.section-tab'),
					    tabsNames = [];

					var $tabsSectionButtons = $('<div />', { 'class': 'section-tabs__buttons' }).append($('<ul />'));
					$tabsSectionItems.each(function (sectionItemId, sectionItem) {
						var $sectionItem = $(sectionItem);
						var $tabButton = $('<button />', { 'class': 'section-tabs__button js-section-tabs-button', 'data-id': $sectionItem.attr('id') }).html($sectionItem.data('tab-name'));

						if (sectionItemId != 0) $sectionItem.hide();else $tabButton.addClass('active');

						$tabsSectionButtons.find('ul').append($('<li />').append($tabButton));
					});
					$tabsSection.find('.s-content').prepend($tabsSectionButtons);
				});
			}

			this.actions();
		}
	}, {
		key: 'actions',
		value: function actions() {
			$('.js-section-tabs-button').on('click', function (e) {
				var $tabButton = $(this),
				    $tabId = $tabButton.data('id'),
				    $parentSection = $tabButton.closest('.cms-section');

				if (!$tabButton.hasClass('active')) {
					$parentSection.find('.section-tab').fadeOut(300);
					$parentSection.find('.section-tabs__button').removeClass('active');

					setTimeout(function () {
						$tabButton.addClass('active');
						$('#' + $tabId).fadeIn();
					}, 300);
				}
			});
		}
	}]);

	return TabsSection;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\validator.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validator = exports.Validator = function () {
    function Validator() {
        _classCallCheck(this, Validator);
    }

    _createClass(Validator, [{
        key: 'init',
        value: function init() {
            $(document).ready(function () {
                if ($('.site-content form').length) {
                    $('.grecaptcha-badge').addClass('show');
                }
            });

            $('input, textarea').keydown(function () {
                $(this).siblings('label').addClass('focus');
            });

            $('input, textarea').focusout(function () {
                if ($(this).val().length == 0) {
                    $(this).siblings('label').removeClass('focus');
                }
            });

            $.extend($.validator.messages, {
                required: "To pole jest wymagane.",
                remote: "Proszę o wypełnienie tego pola.",
                email: "Proszę o podanie prawidłowego adresu email.",
                url: "Proszę o podanie prawidłowego URL.",
                date: "Proszę o podanie prawidłowej daty.",
                dateISO: "Proszę o podanie prawidłowej daty (ISO).",
                number: "Proszę o podanie prawidłowej liczby.",
                digits: "Proszę o podanie samych cyfr.",
                creditcard: "Proszę o podanie prawidłowej karty kredytowej.",
                equalTo: "Proszę o podanie tej samej wartości ponownie.",
                extension: "Proszę o podanie wartości z prawidłowym rozszerzeniem.",
                nipPL: "Proszę o podanie prawidłowego numeru NIP.",
                phonePL: "Proszę o podanie prawidłowego numeru telefonu.",
                maxlength: $.validator.format("Proszę o podanie nie więcej niż {0} znaków."),
                minlength: $.validator.format("Proszę o podanie przynajmniej {0} znaków."),
                rangelength: $.validator.format("Proszę o podanie wartości o długości od {0} do {1} znaków."),
                range: $.validator.format("Proszę o podanie wartości z przedziału od {0} do {1}."),
                max: $.validator.format("Proszę o podanie wartości mniejszej bądź równej {0}."),
                min: $.validator.format("Proszę o podanie wartości większej bądź równej {0}."),
                pattern: $.validator.format("Pole zawiera niedozwolone znaki.")
            });

            $.validator.addMethod('filesize', function (value, element, param) {
                var result = true;

                if (element.files.length === 0) {
                    return result;
                }

                Array.from(element.files).forEach(function (file) {
                    result &= file.size <= param;
                });

                return result;
            }, 'Rozmiar pliku musi być mniejszy niż {0}B');

            if ((typeof contactFormRules === 'undefined' ? 'undefined' : _typeof(contactFormRules)) == 'object') {
                var $_FORM = $('#contactForm'),
                    submitHandler = function submitHandler(form) {
                    event.preventDefault();
                    if (typeof grecaptcha !== 'undefined') {
                        var recaptchaResponse = grecaptcha.getResponse();
                        if (recaptchaResponse) {
                            ajaxCall();
                        } else {
                            alert("Proszę zaznaczyć reCAPTCHA.");
                        }
                    } else {
                        console.log("reCAPTCHA nie jest załadowana.");
                    }
                },
                    ajaxCall = function ajaxCall(appendData) {
                    return $.ajax({
                        url: $_FORM.attr("action"),
                        method: 'POST',
                        data: ajaxData(appendData),
                        beforeSend: ajaxBeforeSend,
                        success: ajaxSuccess,
                        error: ajaxError
                    });
                },
                    ajaxData = function ajaxData(appendData) {
                    var serialized = $_FORM.serialize();

                    if ((typeof appendData === 'undefined' ? 'undefined' : _typeof(appendData)) !== 'object') {
                        return serialized;
                    }

                    $.each(appendData, function (key, value) {
                        serialized += '&' + key + '=' + value;
                    });

                    return serialized;
                },
                    ajaxBeforeSend = function ajaxBeforeSend() {
                    $_FORM.find('button').prop('disabled', 'disabled');
                },
                    ajaxSuccess = function ajaxSuccess() {
                    callFbq();

                    $_FORM.find('input, textarea').val('');
                    $_FORM.fadeOut(500, function () {
                        $_FORM.replaceWith('<p class="form__message form__message--success">Wiadomość została wysłana. Dziękujemy.</p>').fadeIn(500);
                    });
                },
                    ajaxError = function ajaxError() {
                    $_FORM.find('input, textarea').val('');
                    $_FORM.fadeOut(500, function () {
                        $_FORM.replaceWith('<p class="form__message form__message--error">Wiadomość nie została wysłana. Prosimy spróbować później.</p>').fadeIn(500);
                    });
                },
                    callFbq = function callFbq() {
                    if (typeof fbq === 'function') {
                        fbq('track', 'Lead');
                    }
                };

                $_FORM.validate({
                    rules: contactFormRules,
                    errorPlacement: function errorPlacement(error, element) {},
                    submitHandler: submitHandler
                });
            }

            if ((typeof accreditationFormRules === 'undefined' ? 'undefined' : _typeof(accreditationFormRules)) == 'object') {
                $('#accreditationForm').submit(function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                });

                $('#accreditationForm').validate({
                    rules: accreditationFormRules,
                    lang: 'pl',
                    errorPlacement: function errorPlacement(error, element) {
                        error.appendTo(element.parent("div"));
                    },
                    submitHandler: function submitHandler(form) {
                        form.submit();
                    }
                });
            }
        }
    }]);

    return Validator;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\video.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Video = exports.Video = function () {
	function Video() {
		_classCallCheck(this, Video);
	}

	_createClass(Video, [{
		key: 'init',
		value: function init() {
			var self = this;
			$('.video-player').hover(function (e) {
				e.preventDefault();
				var $this = $(this);
				self.play($this);
			}, function (e) {
				e.preventDefault();
				var $this = $(this);
				self.stop($this);
			});
		}
	}, {
		key: 'play',
		value: function play(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.play();
			}
		}
	}, {
		key: 'stop',
		value: function stop(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.pause();
			}
		}
	}]);

	return Video;
}();

},{}],"D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\modules\\visible.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Visible = exports.Visible = function () {
	function Visible() {
		_classCallCheck(this, Visible);
	}

	_createClass(Visible, [{
		key: 'init',
		value: function init() {
			var elem = $('.features-list__item, .text, .mini-gallery__item, .articles-list__item, .download-files__item');

			elem.each(function () {
				var $this = $(this),
				    elemVisible = $this.visible(true, 'vertical');

				if (elemVisible) $this.addClass('on-screen', elemVisible);
			});

			$(window).scroll(function () {
				elem.each(function () {
					var $this = $(this),
					    elemVisible = $this.visible(true, 'vertical');

					if (elemVisible) $this.addClass('on-screen', elemVisible);
				});
			});

			this.delay($('.features-list--link-box .features-list__item'));
			// this.delay($('.articles-list--news .articles-list__item'));
		}
	}, {
		key: 'delay',
		value: function delay(elem) {
			elem.each(function (index) {
				$(this).css('transition-delay', 100 * index + 'ms');
			});
		}
	}]);

	return Visible;
}();

},{}]},{},["D:\\laragon-www\\knockout-www\\www\\resources\\assets\\scripts\\src\\main.js"])

